import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { GdprModalMessageService } from './gdpr-modal-message.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import {UtilService} from '../../services/util.service';
import {SessionService} from '../../services/session.service';
import {ProfileService} from '../profile/profile.service';
import {MiddlemanService} from '../../services/middleman.service';
import { ConfigService } from 'app/core/services/config.service';

@Component({
    selector: 'itpx-gdpr-modal-message',
    templateUrl: './gdpr-modal-message.component.html',
    styleUrls: ['./gdpr-modal-message.component.css']
})
export class GdprModalMessageComponent extends RxComponent implements OnInit {
    private isConfirmButtonDisabled: boolean;
    private empoloyeeDetails: any;
    confirmGdprForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        private modalService: SmartModalService,
        private service: GdprModalMessageService,
        private authService: AuthService,
        private router: Router,
        private utilService: UtilService,
        private sessionService: SessionService,
        private profileService: ProfileService,
        private middlemanService: MiddlemanService,
        private configService: ConfigService
    ) {
        super();
    }

    ngOnInit() {
        const bgImageUrl = `${this.configService.get('aws').downloadUrl}/${this.configService.get('aws').cdnBucket}/images/prod-bg.jpg`;
        this.utilService.hidePartials(bgImageUrl);
        this.empoloyeeDetails = this.middlemanService.getData();
        this.confirmGdprForm = this.fb.group({
            confirmPolicy: ['', Validators.required]
        });
        this.confirmGdprForm.controls.confirmPolicy.valueChanges.subscribe(change => {
            if (!change) {
                this.isConfirmButtonDisabled = true;
            } else {
                this.isConfirmButtonDisabled = false;
            }
        });

        if(!this.empoloyeeDetails) {
            this.profileService.getProfile()
                .subscribe(
                    body =>  this.empoloyeeDetails = body['data']
                )
        }
    }
    ngOnDestroy() {
        this.utilService.showPartials();
        this.middlemanService.clear();
    }

    private onCancel() {
        this.authService.logout();
    }

    private confirmPolicyAcceptance() {
        let details = {};
        details['email'] = this.empoloyeeDetails.email;
        details['privacyPolicyAcceptanceVersion'] = '1';
        details['privacyPolicyAcceptanceTimeStamp'] = Date.now();
        this.service.updateEmployeeDetails(details)
          .subscribe(
            data => {
                this.onSuccessNavigate();
            },
            error => {
              this.onCancel();
            }
          )
    }
    private onSuccessNavigate() {
        let lastState = this.empoloyeeDetails.previousUrl;
        console.log(lastState)
        let route = lastState || 'dashboard';
        let queryParams = {};
        let routeParams = {};
        if (lastState && lastState.split('?').length > 1) {
            route = lastState.split('?')[0];
            queryParams = this.buildQueryParams(lastState.split('?')[1]);
        } else if (lastState && lastState.indexOf('%3Aid') > -1) {
            route = lastState.split(';')[0];
            routeParams = this.buildQueryParams(lastState.split(';')[1]);
        }
        this.router.navigate([route, routeParams], { queryParams: queryParams });
    };

    private buildQueryParams(str: string): any {
        let result = {};
        let pairs = str.split('&');
        pairs.forEach(el => {
            result[el.split('=')[0]] = el.split('=')[1];
        });

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/app/core/components/gdpr-modal-message/gdpr-modal-message.component.ts